import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import jobImg from "../../assets/img/about/job-2.png";

const SingleJob = (props) => {
  const navigate = useNavigate();

  const jobData = {
    "DevOps Engineer": {
      description:
        "Are you passionate about automation, cloud, and modern infrastructure? We're looking for a DevOps Engineer (Fresher) to join our growing tech team. This is a great opportunity for someone who wants to launch their career in DevOps, CI/CD, and Cloud Engineering with real-time project experience, mentoring, and growth potential.",
      responsibilities: [
        "Assist in building and maintaining CI/CD pipelines using tools like Jenkins, GitHub Actions, or GitLab. Work with tools like Docker, Kubernetes, Terraform, and Ansible.",
        "Support deployment, monitoring, and scaling of applications on cloud platforms (AWS/Azure/GCP).",
        "Write scripts using Bash, Shell, or Python to automate routine operations.",
        "Manage source code with Git, and participate in version control workflows.",
        "Collaborate with development and QA teams to ensure smooth releases.",
        "Monitor system performance and respond to incidents.",
      ],
    },
    "Full Stack Developer": {
      description:
        "Kickstart your software development journey with hands-on experience in both frontend and backend technologies. As a Full Stack Developer intern, you'll build complete web applications, collaborate with teams, and work on real-world features using tools like Java, Spring Boot, React.js, and REST APIs.",
      responsibilities: [
        "Develop and maintain front-end components using React.js, HTML, CSS, and JavaScript.",
        "Build secure and scalable backend APIs using Java, Spring Boot, and MySQL.",
        "Integrate frontend and backend for smooth, dynamic user experiences.",
        "Participate in code reviews, debugging, and testing.",
        "Use tools like Git, Postman, and Swagger to document and test APIs.",
        "Learn and apply DevOps basics like CI/CD and deployment.",
        "Collaborate with the QA and design teams to deliver polished features.",
      ],
    },
    "Full Stack Tester": {
      description:
        "As a Full Stack Tester, you'll work across both frontend and backend layers to ensure software quality. You'll gain exposure to manual testing, API testing, and automation tools, helping ensure bug-free releases in a fast-paced environment.",
      responsibilities: [
        "Perform manual testing of web applications including UI, functionality, and usability.",
        "Write and execute test cases, report bugs, and track issues.",
        "Conduct API testing using tools like Postman and validate backend responses.",
        "Collaborate with developers to understand requirements and test flows.",
        "Learn and assist in automation scripting using tools like Selenium or JUnit.",
        "Perform regression, smoke, and integration testing.",
        "Ensure quality across multiple browsers and devices.",
      ],
    },
  };

  const handleApply = (title) => {
    const job = jobData[title];

    if (!job) {
      alert("Job data not found.");
      return;
    }
    navigate("/job-details", {
      state: {
        title,
        description: job.description,
        responsibilities: job.responsibilities,
      },
    });
  };

  const {
    itemClass,
    Image,
    Title,
    Location,
    officeTime,
    salaryRange,
    btnText,
  } = props;
  return (
    <div className={itemClass ? itemClass : "job__item"}>
      <div className="job__top-item d-flex align-items-center pb-30">
        <div className="job__img pr-20">
          <img src={Image ? Image : jobImg} alt="" />
        </div>
        <h5 className="job__title-sm">
          {Title ? Title : "Lead Product Design"}
        </h5>
      </div>
      <div className="job__button">
        <button onClick={() => handleApply(Title)} className="apply-btn">
          Apply Now
        </button>
      </div>
    </div>
  );
};

export default SingleJob;
